import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClipboardService } from '../../../service/clipboard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-copy-text-to-clipboard',
    standalone: false,
    templateUrl: './copy-text-to-clipboard.component.html',
    styleUrl: './copy-text-to-clipboard.component.scss'
})
export class CopyTextToClipboardComponent implements OnInit {
    protected data = inject<{ title: string, content: string, showContent: boolean }>(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<CopyTextToClipboardComponent>);
    private copyService = inject(ClipboardService);
    private destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: event => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    protected close(): void {
        this.dialogRef.close(false);
    }

    protected copy() {
        this.copyService.copyToClipboard(this.data.content);
    }
}

